import * as $ from 'jquery';
import { MediaMatcher } from '@angular/cdk/layout';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';

import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../services/auth.service';
import { Globals } from '../../shared/globals';
import { AccountService } from '../../services/account.service';
import { LicenseCoverage } from '../../models/license-coverage.model';

/** @title Responsive sidenav */
@Component({
  selector: 'app-full-layout',
  templateUrl: 'full.component.html',
  styleUrls: [],
})
export class FullComponent implements OnInit, OnDestroy, AfterViewInit {
  mobileQuery: MediaQueryList;
  dir = 'ltr';
  green: boolean;
  blue: boolean;
  dark: boolean;
  minisidebar: boolean;
  boxed: boolean;
  danger: boolean;
  ecarup: boolean;
  showHide: boolean;
  sidebarOpened;

  public licenseInfo: LicenseCoverage | null = null;
  public config: PerfectScrollbarConfigInterface = {};
  private _mobileQueryListener: () => void;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public translate: TranslateService,
    public authService: AuthService,
    private globals: Globals,
    private accountService: AccountService
  ) {
    this.ecarup = true;
    this.boxed = false;
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  public setLanguage(language: string): void {
    // this.translate.use(language.match(/en|de|fr|it|pl|fi|nl/) ? language : 'en');
    const lang = language.match(/en|de|fr|it/) ? language : 'en';
    this.translate.use(lang);

    localStorage.setItem('language', lang);
  }

  getTranslatedNewsLink(): string {
    const lang = this.translate.currentLang || this.translate.defaultLang;
    switch (lang) {
      case 'de':
        return 'https://sites.google.com/smart-me.com/ecarup-wiki/startseite';
      case 'fr':
        return 'https://sites.google.com/smart-me.com/wiki-fr';
      case 'en':
      default:
        return 'https://sites.google.com/smart-me.com/wiki-english/home';
    }
  }

  public logout(): void {}

  async ngOnInit(): Promise<void> {
    try {
      this.licenseInfo = await this.accountService.getLicenseCoverage();
    } catch (error) {
      console.error('Error fetching license information:', error);
    }
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  ngAfterViewInit(): void {
    // This is for the topbar search
    (<any>$('.srh-btn, .cl-srh-btn')).on('click', function () {
      (<any>$('.app-search')).toggle(200);
    });
    // This is for the megamenu
  }
}
